import { create } from "zustand";

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

function daysAgoISO(n) {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - n);
  return d.toISOString().slice(0, 10);
}

// 백엔드 MAX_RANGE_DAYS=90 — "전체"는 무제한이 아니라 조회 가능한 최대 기간(최근 90일).
export const MAX_RANGE_DAYS = 90;

// 2026-07-15: 헤더의 전역 날짜 범위(from/to)·프리셋 액션·granularity 제거 — 페이지 전체에
// 적용되는 것처럼 보였지만 실제로는 "사용량" 카드에만 영향을 주고 각 탭(전체 사용자/추세)은
// 이미 자체 SectionRangePicker로 독립 동작해서 혼란스러웠다. 이제 모든 구간이 각자 own range를
// 갖는 동일한 패턴으로 통일됐고, 이 스토어엔 여러 화면이 공유하는 pool만 남는다.
export const useFilterStore = create((set) => ({
  // ainova.news(nova 풀) 전용 대시보드 — sedaily(사내 SSO, enlab) 풀은 조회 대상에서 제외.
  // 예전엔 "all"(두 풀 합산)이 기본값이었으나, 서로 다른 사용자군을 합쳐 보여주는 게
  // 오히려 혼란이라 nova 단일 풀로 고정(2026-07-15). pool 을 바꾸는 UI 자체가 없으므로
  // 사실상 상수 — 값을 바꾸려면 이 기본값을 직접 수정해야 한다.
  pool: "nova",

  // 조회 환경(view env) — prod/stg 데이터 가시성 (2026-09-10, 결함 B).
  // 기본 prod(기존 동작). STG 로 바꾸면 모든 read API 가 stg 테이블을 조회하고,
  // 쓰기/관리 액션은 UI 에서 비활성화된다(STG VIEW = READ ONLY). 백엔드도 env=stg
  // 쓰기 요청은 403 으로 fail-closed 하므로, 프론트 비활성화가 뚫려도 안전하다.
  env: "prod",
  setEnv: (env) => set({ env: env === "stg" ? "stg" : "prod" }),
}));

// STG 조회 상태에서는 모든 mutation(크레딧 지급/회수, 지출, 메일, 역할부여 등)이 금지된다.
// 컴포넌트가 write 컨트롤을 disable 할지 판정하는 단일 기준.
export function isReadOnlyEnv(env) {
  return env === "stg";
}

// 연/월 단위 이동 — 날짜 input 을 드래그·스크롤 없이 버튼으로 앞뒤 이동.
export function shiftDate(iso, { years = 0, months = 0 } = {}) {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCFullYear(d.getUTCFullYear() + years);
  d.setUTCMonth(d.getUTCMonth() + months);
  return d.toISOString().slice(0, 10);
}

export function daysAgoISODate(n) {
  return daysAgoISO(n);
}

export function todayISODate() {
  return todayISO();
}
